import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _get from 'lodash.get';
import s from './MatchCenterLiveCard.scss';

const MatchCenterLiveCard = props => {
  if (props) {
    const { liveMatchCardData } = props;
    const {
      currPartnerShip,
      currentBowler,
      currentBattingTeam,
      score,
      currRate,
      teamainnings,
      teambainnings,
      equation,
    } = liveMatchCardData;
    const inningsMap = ['1st innings', '2nd innings'];
    let currentInningsNo;
    const parentInnig1Classname = classnames({
      [`${s.inn}`]: true,
      [`${s.yetToBatContainer}`]:
        teamainnings?.score &&
        Array.isArray(teamainnings?.score) &&
        teamainnings?.score.length === 0,
    });
    const parentInnig2Classname = classnames({
      [`${s.inn}`]: true,
      [`${s.yetToBatContainer}`]:
        teambainnings?.score &&
        Array.isArray(teambainnings?.score) &&
        teambainnings?.score.length === 0,
    });
    const getCurrentInningsNumber = () => {
      if (
        currentBattingTeam === teamainnings?.battingteamName &&
        teamainnings?.score &&
        Array.isArray(teamainnings?.score) &&
        teamainnings?.score.length > 0
      ) {
        currentInningsNo = teamainnings.score.length;
      } else if (
        currentBattingTeam === teambainnings?.battingteamName &&
        teambainnings?.score &&
        Array.isArray(teambainnings?.score) &&
        teambainnings?.score.length > 0
      ) {
        currentInningsNo = teambainnings.score.length;
      }
    };
    getCurrentInningsNumber();
    return (
      <>
        {currentBattingTeam && (
          <>
            <div className={s.livematch_wrapper}>
              <div className={s.score_inning_wrap}>
                <div className={s.flag_score}>
                  <div className={s.flag}>
                    <i className={`${s.icon} ${s[currentBattingTeam]}`} />
                  </div>
                  <div className={s.score}>
                    <div className={s.info_text}>
                      {inningsMap[currentInningsNo - 1]}
                    </div>
                    <div className={s.score_crr}>
                      {currentBattingTeam} <span>{score}</span>
                      <span className={s.crr}>CRR: {currRate}</span>
                    </div>
                  </div>
                </div>
                <div className={s.team_inning}>
                  {teamainnings?.battingteamName && (
                    <div className={parentInnig1Classname}>
                      <div className={s.name}>
                        {teamainnings?.battingteamName}:
                      </div>
                      <div>
                        {teamainnings && (
                          <>
                            {teamainnings?.score &&
                              teamainnings?.score.map((scre, index) => (
                                <div>
                                  {inningsMap[index]}: <span>{scre}</span>
                                </div>
                              ))}
                          </>
                        )}
                        {teamainnings?.score &&
                          Array.isArray(teamainnings?.score) &&
                          teamainnings?.score.length === 0 && (
                            <div>Yet To Bat</div>
                          )}
                        {/* <div>
                        1st innings: <span>310/10</span>
                      </div>
                      <div>2nd innings:</div> */}
                      </div>
                    </div>
                  )}
                  {teambainnings?.battingteamName && (
                    <div className={parentInnig2Classname}>
                      <div className={s.name}>
                        {teambainnings?.battingteamName}:
                      </div>
                      <div>
                        {teambainnings && (
                          <>
                            {teambainnings?.score &&
                              teambainnings?.score.map((scre, index) => (
                                <div>
                                  {inningsMap[index]}: <span>{scre}</span>
                                </div>
                              ))}
                          </>
                        )}
                        {teambainnings?.score &&
                          Array.isArray(teambainnings?.score) &&
                          teambainnings?.score.length === 0 && (
                            <div>Yet To Bat</div>
                          )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={s.batter_bowler}>
                <div className={s.heading}>{equation}</div>
                <ul className={s.bat_bowl_table}>
                  <li className={s.head}>
                    <span className={s.name}>Batter</span>
                    <span>R</span>
                    <span>B</span>
                    <span>4s</span>
                    <span>6s</span>
                    <span>SR</span>
                  </li>
                  {Array.isArray(currPartnerShip) &&
                    currPartnerShip.length > 0 &&
                    currPartnerShip.map(batsMan => (
                      <li>
                        <span className={s.name}>
                          {batsMan?.Link && (
                            <a href={batsMan?.Link}>
                              {batsMan?.Name}
                              {batsMan?.IsStriker && ' *'}
                            </a>
                          )}
                          {!batsMan?.Link && (
                            <>
                              {batsMan?.Name}
                              {batsMan?.IsStriker && ' *'}
                            </>
                          )}
                        </span>
                        <span>{batsMan?.Runs}</span>
                        <span>{batsMan?.Balls}</span>
                        <span>{batsMan?.Fours}</span>
                        <span>{batsMan?.Sixes}</span>
                        <span>{batsMan?.Strikerate}</span>
                      </li>
                    ))}
                  <li className={`${s.head} ${s.head_2}`}>
                    <span className={s.name}>Bowler</span>
                    <span>O</span>
                    <span>M</span>
                    <span>R</span>
                    <span>W</span>
                    <span>ECO</span>
                  </li>
                  {currentBowler &&
                    Array.isArray(currentBowler) &&
                    currentBowler.length > 0 &&
                    currentBowler.map(bowler => (
                      <li>
                        <span className={s.name}>
                          {bowler?.Link && (
                            <a href={bowler?.Link}>{bowler?.Name}</a>
                          )}
                          {!bowler?.Link && <>{bowler?.Name}</>}
                        </span>
                        <span>{bowler?.Overs}</span>
                        <span>{bowler?.Maidens}</span>
                        <span>{bowler?.Runs}</span>
                        <span>{bowler?.Wickets}</span>
                        <span>{bowler?.Economyrate}</span>
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            {/* <i className={`${s.currentBattingTeam} ${s.flagIcon}`} /> */}
          </>
        )}
      </>
    );
  }
  return null;
};
MatchCenterLiveCard.propTypes = {
  liveMatchCardData: PropTypes.objectOf({}),
};
MatchCenterLiveCard.defaultProps = {
  liveMatchCardData: {},
};

export default MatchCenterLiveCard;
